// Baugruppen (freie Gruppen): part.meta.group = { id, name }. Engine-frei.
// Anders als Korpusgruppen (cabinet_id + Anker-Teil) hat eine Baugruppe
// bewusst keinen Anker — die Mitgliedschaft allein definiert sie. Mitglieder
// bewegen und duplizieren sich als Ganzes (Controller/multiselect.js).

export function groupOf(part) {
  return part.meta?.group ?? null
}

// meta-Muster wie miters/cutouts: ohne Gruppe verschwindet der Schlüssel
export function withGroup(part, group) {
  const meta = { ...part.meta }
  if (group) meta.group = { id: group.id, name: group.name }
  else delete meta.group
  return meta
}

export function withoutGroup(part) {
  return withGroup(part, null)
}

export function groupMemberIds(parts, groupId) {
  if (!groupId) return []
  return parts.filter((part) => groupOf(part)?.id === groupId).map((part) => part.client_id)
}

// „Gruppe N“: höchste bereits vergebene Nummer + 1 (Muster: addSketch)
export function nextGroupName(parts) {
  const numbers = parts
    .map((part) => groupOf(part)?.name)
    .filter(Boolean)
    .map((name) => parseInt(name.replace(/\D+/g, ""), 10) || 0)
  return `Gruppe ${Math.max(0, ...numbers) + 1}`
}
